import { HttpMethod, ApiResultModel } from '@truckdown/systems';
import context from '@truckdown/components-systems';
import { defineComponent, ref, Ref } from 'vue';

interface IData {
    fileStatus: Ref<string>,
    isDragging: Ref<boolean>,
    fileInput: Ref<HTMLInputElement | null>,
    uploadedFile: Ref<File | undefined>
}

const getData = function () {
    return {
        fileStatus: ref<string>(""),
        uploadedFile: ref<File | undefined>(),
        isDragging: ref<boolean>(false),
        fileInput: ref<HTMLInputElement | null>(null)
    } as IData;
}

const MAX_FILE_SIZE_MB = 15;
const ALLOWED_EXTENSIONS = ['.xlsx', '.csv', '.xls', '.ods'];

const validateFile = function (file: File): boolean {
    const ext = '.' + file.name.split('.').pop()?.toLowerCase();
    return ALLOWED_EXTENSIONS.indexOf(ext) !== -1;
};

const upload = async function (data: IData, file: any) {
    data.fileStatus.value = "pending";
    try {
        let manager = context.apiManager;

        const formData = new FormData();
        formData.append('file', file);

        let request = manager.createRequest({
            service: "main",
            path: "/accounts/fleet-onboarding/import",
            method: HttpMethod.POST
        }, formData);

        var res = await manager.get<ApiResultModel>(request);

        if (res.ok) {
            data.fileStatus.value = "success";
        } else {
            data.fileStatus.value = "error";
            console.error('Error uploading file:', res);
        }
    } catch (error) {
        console.error('Error uploading file:', error);
        data.fileStatus.value = "error";
    }
}


const getMethods = function (data: IData) {
    return {
        triggerFileSelect: function () {
            data.fileInput.value?.click();
        },
        onDragOver: function (event: DragEvent) {
            event.preventDefault();
            data.isDragging.value = true;
        },

        onDragLeave: function () {
            data.isDragging.value = false;
        },

        onDrop: async function (event: DragEvent) {
            event.preventDefault();
            data.isDragging.value = false;
            if (!event.dataTransfer) return;
            const droppedFile = event.dataTransfer.files[0];
            if (droppedFile) {
                data.uploadedFile.value = droppedFile;
                if (validateFile(droppedFile)) {
                    await upload(data, droppedFile);
                } else {
                    alert('Only .xlsx, .csv, .xls, .ods files are allowed.');
                }
            } else {
                return;
            }
        },
        onFileChange: async function (event: Event) {
            const input = event.target as HTMLInputElement;
            const file = input.files?.[0];
            if (!file) return;
            data.uploadedFile.value = file;
            if (validateFile(file)) {
                await upload(data, file);
            } else {
                alert('Only .xlsx, .csv, .xls, .ods files are allowed.');
                input.value = '';
            }
        }
    };
}

export default defineComponent({
    props: {
    },
    name: "fleet-setup-vendors-setup",
    emits: [],
    components: {
    },
    setup: function (props: any, ctx: any) {
        const data = getData();
        const methods = getMethods(data);

        return {
            ...data,
            ...methods
        };
    }
});